module.exports = __webpack_public_path__ + "static/media/guide_4.db8d9cc4.svg";